'use strict';

const timeFilter = require('../../../../../utils/timestamp-util').timestampToDateFilter;

function parse(reader) {
    const version = reader.readUInt8("version");

    reader.readUInt32LE("data.timestamp", timeFilter);
    reader.readUInt8("data.mobile_signal");
    reader.readBit(1, "data.din");
    reader.readBit(1, "data.dout");

    reader.readUInt8("data.ain_1.count");
    reader.readUInt32LE("data.ain_1.time_step");
    if (version >= 2 || reader.getLength() === 55) {
        reader.readFloatLE("data.ain_1.values.ccy");
    }
    reader.readFloatLE("data.ain_1.values.max");
    reader.readFloatLE("data.ain_1.values.min");
    reader.readFloatLE("data.ain_1.values.avg");

    reader.readUInt8("data.ain_2.count");
    reader.readUInt32LE("data.ain_2.time_step");
    if (version >= 2 || reader.getLength() === 55) {
        reader.readFloatLE("data.ain_2.values.ccy");
    }
    reader.readFloatLE("data.ain_2.values.max");
    reader.readFloatLE("data.ain_2.values.min");
    reader.readFloatLE("data.ain_2.values.avg");
}

module.exports.parse = parse;



// WEBPACK FOOTER //
// ./src/lib/ucp/parsers/mode/cloud/v1_2/analog/regular-report-parser.js